import { VerticalLayoutProps } from '@src/components/layouts/VerticalLayout';
import { ContentWidth } from '@src/@data/store/LayoutProvider';
import { AdminMenu } from '@src/pages/admin/AdminMenu';
import { ComponentType, lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import {
  ROUTE_AUTH,
  ROUTE_COMPANIES,
  ROUTE_COMPANIES_CREATE,
  ROUTE_CREATE_COMPANY_WIZARD,
  ROUTE_ERROR,
  ROUTE_STRIPE_SETUP,
  ROUTE_ADMIN,
} from './consts';

export interface RouteEntry extends RouteProps {
  path: string;
  component: ComponentType;
  layout: 'BlankLayout' | 'VerticalLayout';
  meta?: {
    authRoute?: boolean;
    publicRoute?: boolean;
    companyCreateRoute?: boolean;
    contentWidth?: ContentWidth;
    menuCollapsed?: boolean;
    menuHidden?: boolean;
    navLink?: string;
  };
  appLayout?: boolean;
  className?: string;
  layoutProps?: Pick<VerticalLayoutProps, 'navbar' | 'footer' | 'menu'>;
}

export const RouteEntries: Record<string, RouteEntry> = {
  auth: {
    path: ROUTE_AUTH,
    component: lazy(() => import('../../pages/auth/AuthPage')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  error: {
    path: ROUTE_ERROR,
    component: lazy(() => import('../../pages/Error')),
    layout: 'BlankLayout',
  },
  create_company: {
    path: ROUTE_COMPANIES_CREATE,
    component: lazy(() => import('../../pages/create-company/CreateCompany')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: false,
      companyCreateRoute: true,
    },
  },
  create_company_wizard: {
    path: ROUTE_CREATE_COMPANY_WIZARD,
    component: lazy(
      () => import('../../pages/create-company-wizard/CreateCompanyWizard')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: false,
    },
  },
  companies: {
    path: ROUTE_COMPANIES,
    component: lazy(() => import('../../pages/my-companies')),
    layout: 'VerticalLayout',
    meta: {
      publicRoute: false,
    },
  },
  stripe: {
    path: ROUTE_STRIPE_SETUP,
    component: lazy(() => import('../../pages/stripe/StripeSetupSuccess')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: false,
    },
  },
  admin: {
    path: ROUTE_ADMIN,
    component: lazy(() => import('../../pages/admin/AdminPage')),
    layout: 'VerticalLayout',
    layoutProps: {
      menu: <AdminMenu />,
    },
    meta: {
      publicRoute: false,
    },
  },
};

// ** Default Route
export const DefaultRouteEntry = RouteEntries['companies'];
